module.exports = __webpack_public_path__ + "img/03.602a56d9.jpg";